
export const initialPaginationState = (params = {}) => ({
  page: 1,
  total: 1,
  lastPage: 1,
  perPage: 20,
  search: '',
  ids: [],
  ...params
})
